import { PRIMARY_LOCAL_ENVIRONMENT_ID } from "@afar-research/contracts";

/**
 * The Desktop Client's bearer session for its local Environment, or null in a browser.
 *
 * The main process pairs it with an owner grant and keeps it; the renderer only borrows it for one
 * request or one ticket exchange. `refresh` asks for a new pairing after the Environment refused
 * the last one — a service restarted on a fresh Host Store, say.
 */
export async function readDesktopPrimaryBearer(options?: {
  readonly refresh?: boolean;
}): Promise<string | null> {
  const bridge = typeof window === "undefined" ? undefined : window.desktopBridge;
  if (bridge === undefined) return null;
  return bridge.getLocalEnvironmentBearerToken({
    environmentId: PRIMARY_LOCAL_ENVIRONMENT_ID,
    ...(options?.refresh ? { refresh: true } : {}),
  });
}
